<template>
  <div class="change-single-tip">
    <el-dialog title="改单提示" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div>
        <p>改单需同时满足以下3种条件，海关才会接受更改申请：</p>
        <p style="color:#ED6A0C">1.你想修改的舱单海关已经回执；</p>
        <p style="color:#ED6A0C">2.货物尚未报关，舱单尚未被报关核注；</p>
        <p style="color:#ED6A0C">3.装船前24小时以上；</p>
        <p style="margin-top:40px">以下9类数据不能修改，如果需要修改请删单后重新发送：</p>
        <p style="color:#ED6A0C">船公司、船代、船名、航次、提单号、箱号、箱型、封号、货名。</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" class="submit-btn" @click="startUpdateOrder">继续</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "UpdateOrderTip",
  props: {
    visible: Boolean,
  },
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    },
    startUpdateOrder(){
      this.$emit("startUpdateOrder")
      this.$emit("closeDialog")
    }
  }
}
</script>

<style scoped lang="less">
.change-single-tip {
  color: #333333;
  font-size: 14px;
  .dialog-footer {
    text-align: right;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 80px;
    padding: 0;
  }
  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
}
</style>